<template>
  <div>
    <el-form-item :label="imgTitle">
      <div class="crop-demo">
        <div class="el-upload" v-show="formData.base64==''">
          <i class="el-icon-plus"></i>
        </div>
        <div class="crop-demo-file">
          <input
              class="crop-input"
              type="file"
              name="image"
              accept="image/*"
              @change="setImage"
          />
        </div>
        <img :src="formData.base64" class="pre-img" v-show="formData.base64!=''"/>
      </div>
    </el-form-item>
  </div>
</template>

<script>

export default {
  data() {
    return {
      defaultSrc: require("../../assets/img/img.jpg"),
      imgSrc: "",
      dialogVisible: false,
      formData: {
        base64: ""
      },
      imgData: ""
    };
  },
  props: {
    editImg: String,
    imgTitle: String
  },
  watch: {
    'editImg': function () {
      this.formData.base64 = this.editImg
    }
  },
  created() {
    this.formData.base64 = "";
  },
  methods: {
    setImage(e) {

      const file = e.target.files[0];
      if (!file.type.includes("image/")) {
        return;
      }
      const reader = new FileReader();
      reader.onload = event => {
        //this.dialogVisible = true;
        this.imgSrc = event.target.result;
        this.$refs.cropper && this.$refs.cropper.replace(event.target.result);

        this.formData = {
          base64: this.imgSrc
        };
        this.$axios.post("/Upload/Base64", this.formData).then(res => {
          if (res.data.hasError == false) {
            this.imgData = res.data.data;
            this.$emit("uploadImg", this.imgData);
          } else {
            this.$message.error('上传错误')
            this.formData.base64 = this.defaultSrc;
          }
        });
      };
      reader.readAsDataURL(file);
    },
    cropImage() {
    },
    cancelCrop() {
      this.dialogVisible = false;
      this.formData.base64 = this.defaultSrc;
    }
  },
  components: {
  }
};
</script>

<style lang="scss">
.crop-demo {
  position: relative;

  .crop-demo-file {
    position: absolute;
    height: 100px;
    width: 100px;
    overflow: hidden;

    .crop-input {
      height: 100px;
      opacity: 0;
    }
  }
}

.el-upload {
  width: 100px;
  height: 100px;
  border: 1px dashed #c0ccda;
  background: #fbfdff;
  border-radius: 6px;
  text-align: center;
  line-height: 100px;

  .el-icon-plus {
    font-size: 28px;
    color: #8c939d;
  }
}
</style>